export const getMode = () =>
  ({
    IS_DEV: import.meta.env.MODE === 'development',
    IS_PROD: import.meta.env.PROD,
  } as const);
